<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between">
            <div>
                <h1 class="text-2xl font-semibold text-[#24723b]">OHR Form Request</h1>
                <p  class="text-xs text-[#747474] mt-2">Home / OHR Form Request</p>
            </div>
            <div >
                <button  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1' , notactive: activeBtn === 'Button2'}">Requests Status</button>
                <button  class="py-3 px-5 rounded-md text-sm w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2', notactive: activeBtn === 'Button1'}">Finished Requests</button>
            </div>
        </div>
    </div>
    <div class="mt-11">
      
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl :Action="true" v-if="activeBtn === 'Button1'" :header="header" :column="column" :info="info" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton" />                
            <TableControl :Action="true" v-if="activeBtn === 'Button2'" :header="header1" :column="columnapproved" :VButton="true" :info="infoapproved" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"  @ViewButton="ViewButton"/>                
        </div>
    </div>
    

    <div v-if="test">
        <div @click="test = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[800px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#006A00] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">OHR Form Request</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    <p class="text-green-800"></p>
                    <table>
                        <tr>
                            <td class="text-sm font-medium text-[#0B6014]">Employee</td>
                            <td class="text-sm font-medium pr-11 text-[#0B6014]">:</td>
                            <td class="text-sm ">{{ data.employee_name }}</td>
                        </tr>
                        <tr class="">
                            <td class="text-sm font-medium text-[#0B6014] pt-1">Date</td>
                            <td class="text-sm font-medium pt-1">:</td>
                            <td class="text-sm pt-1">{{ data.date_submitted}}</td>
                        </tr>
                        <tr class="">
                            <td class="text-sm font-medium text-[#0B6014] align-top pt-1">Requests</td>
                            <td class="text-sm font-medium align-top pt-1">:</td>
                            <td class="text-sm pt-1">
                                <div class="flex flex-col gap-1 pb-1">
                                    <span class="" v-for="(row,index) in testser" :key="index">{{ row.forms }}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-sm font-medium text-[#0B6014]">Reason</td>
                            <td class="text-sm font-medium">:</td>
                            <td class="text-sm">{{ data.reason }}</td>
                        </tr>
                    </table>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button v-if="activeBtn === 'Button1'" class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md" v-on:click="ReleaseDocument">Receive</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="test = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    
    <div v-if="hrReceive">
        <Prompt type="HRRECEIVED" @close="hrReceive = false"/>
    </div>

        

    </template>
    <script>
    import Prompt from "../Prompt/RequestPromt.vue"
    import { defineComponent } from 'vue';
    import TableControl from '.././TableControl/TableControl.vue'
    import Services from '../../../services/admin' 
    
    export default defineComponent(
    {
        components:{
            TableControl,
            Prompt
        },
        data(){ 
            return{
                hrReceive:      false,
                activeBtn:      "Button1",
                info:           null,
                test:           false,
                request_key:    '',
                data:           '',
                infoapproved:   '',
                testser:'',
            
                columnapproved:[
                   
                    'employee_name',
                    'date_submitted',
                    'processed_date',
                    'processed_by',
                    'hr_status'
                ],
                header:[
                    {title:'Reference No.'},
                    {title:'Employee Name'},
                    {title:'Date Requested'},
                    {title:'Status'},
                    {title:'Action'},
                  
                    
                ],
                header1:[
                    {title:'Employee Name'},
                    {title:'Date Requested'},
                    {title:'Release Date'},
                    {title:'Processed by'},
                    {title:'Status'},
                    {title:'Action'},
                    
                ],
                column:[
                    'request_key',
                    'employee_name',
                    'date_submitted',
                    'hr_status',
                ],


            }
         },
        mounted(){
            this.GetHRrequestform();
        },
        methods:{
            async GetHRrequestform(){
                this.$emit("showLoader")
                const success = await Services.getRequestForms();
                this.info = success.data
                const approved = await Services.getApprovedRequestForms();
                this.infoapproved = approved.data
                this.$emit("hideLoader")

            },
            GetRequestApproved(){
           
            },
            async ViewButton(row){
                this.$emit("showLoader")
                this.testser = ''
                const success = await Services.getRequestFormsbyid(row.request_key);
                this.testser = success.data
                this.request_key = row.request_key
                this.test = true
                this.data = row
                this.$emit("hideLoader")
            },
            async ReleaseDocument(){
                this.$emit("showLoader")
                let state               = this.$store.state
                const success           = await Services.approvedRequestForms(this.request_key,state.employee_key);
                this.testser            = success.data
                this.GetHRrequestform();
                this.test               = false
                this.$emit("hideLoader")
                this.hrReceive          = true
                
            } 
        },
    })
    </script>
    

    <style scoped>
    .active {

        color: #ffffff;
        background-color: #24723b;
      
      }
      .notactive {
        background-color: #CCAF12;
        color: #ececec;
      }
    </style>
  